import LocationOnIcon from '@mui/icons-material/LocationOn';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Avatar, AvatarGroup, Card, Grid, IconButton, Tooltip } from '@mui/material';
import { IOutlookCalendarEvent } from 'wisestep-api';
import {
  WsColors,
  WsTypography,
  WsTypoVariants,
  GoogleMeetIcon,
  MicrosoftTeamsIcon,
} from 'wisestep-base';

import { VideoConferenceOptions } from './CalendarEvent';

export const generateTimeString = (start?: Date, end?: Date) =>
  `${new Date(start ?? '').toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  })}-${new Date(end ?? '').toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  })}`;

const CalendarEventListingCard = ({
  calendarObj,
  onEdit,
  onCopy,
}: {
  calendarObj: IOutlookCalendarEvent;
  onEdit: () => void;
  onCopy: (content: string) => void;
}) => (
  <Card
    variant="outlined"
    sx={{
      borderRadius: 2,
      p: 2,
      m: 2,
      background: WsColors.TheBlues50,
      height: '28%',
      cursor: 'pointer',
    }}
    onClick={onEdit}
  >
    <Grid container height="100%" rowSpacing={2}>
      <Grid item container xs={12} display="flex">
        <Grid item xs={8} pt={1}>
          <WsTypography variant={WsTypoVariants.TITLE} bold>
            {calendarObj.eventSummary}
          </WsTypography>
        </Grid>
        <Grid item xs={3}>
          <AvatarGroup max={4}>
            {calendarObj?.attendees &&
              calendarObj?.attendees.map((attendeeName: string | null, index) => (
                <Tooltip key={index} title={attendeeName ?? 'Unknown'}>
                  <Avatar>
                    {attendeeName &&
                      attendeeName
                        .split(' ')
                        .map((nameSubStr, index) => {
                          if (index < 2) return nameSubStr[0];
                        })
                        .join('')}
                  </Avatar>
                </Tooltip>
              ))}
          </AvatarGroup>
        </Grid>
        <Grid item xs={1}>
          <IconButton onClick={onEdit}>
            <MoreVertIcon sx={{ width: 24, height: 24 }} />
          </IconButton>
        </Grid>
      </Grid>
      <Grid item container xs={12} display="flex" columnSpacing={1} alignItems="center">
        <Grid item xs={8}>
          <WsTypography variant={WsTypoVariants.SUB_TITLE} bold>
            {generateTimeString(calendarObj?.from, calendarObj?.to)}
          </WsTypography>
        </Grid>
        <Grid item xs={2} />
        <Grid item xs={1}>
          {calendarObj?.location && (
            <Tooltip title="Location (Click to Copy)">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  onCopy(calendarObj?.location ?? '');
                }}
              >
                <LocationOnIcon color="primary" fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Grid>
        <Grid item xs={1}>
          {calendarObj?.meeting && (
            <Tooltip title="Meeting Url (Click to Copy)">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  onCopy(calendarObj?.meeting ?? '');
                }}
              >
                {calendarObj?.entityType === VideoConferenceOptions.GOOGLE_MEET ? (
                  <GoogleMeetIcon />
                ) : (
                  <MicrosoftTeamsIcon />
                )}
              </IconButton>
            </Tooltip>
          )}
        </Grid>
      </Grid>
    </Grid>
  </Card>
);
export default CalendarEventListingCard;
